import React from 'react';
import { Button } from 'primereact/button';

interface Location {
  name: string;
  address: string;
}

interface ReviewProps {
  businessType: string;
  franchiseName: string;
  locations: Location[];
  prevStep: () => void;
  nextStep: () => void;
}

const Review: React.FC<ReviewProps> = ({ businessType, franchiseName, locations, prevStep, nextStep }) => {
  const handleSubmit = async () => {
    console.log("Sending data to the server...");
    console.log("Business Type:", businessType);
    console.log("Franchise Name:", franchiseName);
    console.log("Locations:", locations);
  };

  return (
    <div className="p-4">
      <h2>Review your details</h2>

      <div className="p-mb-3">
        <strong>Business Type:</strong> {businessType}
      </div>

      <div className="p-mb-3">
        <strong>Franchise Name:</strong> {franchiseName}
      </div>

      <div className="p-mb-3">
        <strong>Locations:</strong>
        <ul>
          {locations.map((location, index) => (
            <li key={index}>
              <strong>Location {index + 1}:</strong>
              <br />
              {location.name} - {location.address}
            </li>
          ))}
        </ul>
      </div>

      <div className="p-mb-3">
        <Button label="Submit" icon="pi pi-check" onClick={handleSubmit} className="p-button-success" />
      </div>
      
    </div>
  );
};

export default Review;
